import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { TaskDetailsStakeholders } from '../../interfaces';
import { UpperCasePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SvgComponent } from '../svg-component/svg-component.component';

@Component({
  selector: 'app-stakeholders-info',
  templateUrl: './stakeholders-info.component.html',
  styleUrls: ['./stakeholders-info.component.scss'],
  imports: [UpperCasePipe, TranslateModule, SvgComponent],
})
export class StakeholdersInfoComponent implements OnChanges, OnInit {
  @Input() stakeholders?: TaskDetailsStakeholders;
  /** When false, suppresses the empty-state placeholder (e.g. while loading or after fetch error). */
  @Input() showEmptyPlaceholder = true;
  formattedStakeholders: any[] = [];

  ngOnInit(): void {
    this.formattedStakeholders = this.formatStakeholders(this.stakeholders);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['stakeholders']) {
      this.formattedStakeholders = this.formatStakeholders(this.stakeholders);
    }
  }

  formatStakeholders(stakeholders: TaskDetailsStakeholders | undefined): any[] {
    if (!stakeholders) {
      return [];
    }
    const formattedStakeholders: {
      roleName: string;
      userId: string;
      userName: string;
      depName: string;
      depId: string;
      isCurrentUser: boolean;
      depCount: number;
    }[] = [];
    Object.entries(stakeholders).forEach(([role, people]) => {
      if (Array.isArray(people)) {
        formattedStakeholders.push(
          ...people
            .filter((person: any) => person != null)
            .map((person: any) => ({
              userId: person.userId,
              userName: person.userName,
              depName: person.depName,
              depId: person.depId,
              isCurrentUser: person.isCurrentUser,
              roleName: role,
              depCount: person.depCount,
            })),
        );
      } else if (people != null) {
        formattedStakeholders.push({
          userId: people.userId,
          userName: people.userName,
          depName: people.depName,
          depId: people.depId,
          isCurrentUser: people.isCurrentUser,
          roleName: role,
          depCount: people.depCount,
        });
      }
    });
    return formattedStakeholders;
  }
}
